<template>
  <div class="col-sm-12" id="editFormModal" tabindex="-1">
    <div class="header">
      <span class="title">Edit Form</span>
      <span @click="closeModal" class="btn-close float-right">&times;</span>
    </div>

    <div class="forms-wrapper">
      <form>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label for="name">Name</label>
              <input type="text" :class="['form-control', invalidFields.indexOf('name') === -1 ? '' : 'invalid']" id="name" placeholder="Name of the form" v-model="name">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="title">Title</label>
              <input type="text" :class="['form-control', invalidFields.indexOf('title') === -1 ? '' : 'invalid']" id="title" placeholder="Title of the form" v-model="title">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label for="viewer-url">Viewer URL</label>
              <input type="text" :class="['form-control', invalidFields.indexOf('viewer_url') === -1 ? '' : 'invalid']" id="viewer_url" placeholder="The path to the SVG and thumbnail output" v-model="viewer_url">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="status">Status</label>
              <select class="form-control" id="status" v-model="status">
                <option value="DEV">DEV</option>
                <option value="Enabled">Enabled</option>
                <option value="Disabled">Disabled</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label for="revision-date">Revision Date</label>
              <input type="text" v-mask="'##/##/####'" :class="['form-control', invalidFields.indexOf('revisionDate') === -1 ? '' : 'invalid']" id="revisionDate" placeholder="01/31/2018" v-model="displayRevisionDate">
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="expiration-date">Expiration Date</label>
              <input type="text" v-mask="'##/##/####'" :class="['form-control', invalidFields.indexOf('expirationDate') === -1 ? '' : 'invalid']" id="expirationDate" placeholder="12/31/2018" v-model="displayExpirationDate">
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="version">Version</label>
              <input type="number" :class="['form-control', invalidFields.indexOf('version') === -1 ? '' : 'invalid']" id="version" v-model="version">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label for="practice-area">Library</label>
              <select class="form-control" @change="setPracticeAreaSections" id="practice-area" v-model="practiceArea">
                <option v-for="(area, index) in $store.state.practiceAreas"
                  :key="index"
                  :value="area.name">
                  {{ area.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-4" v-if="!isReplacedTemplate">
            <input accept=".json" type="file" id="selectFilesEdit" value="Import" />
            <input id="replaceTemplates" type="button" class="btn btn-info" @click="getJsonFile" value="Replace Template"/>
          </div>
          <div v-else class="col-sm-4">
            <h4>Global Template Ready</h4>
            <p>Processed {{ totalFields }} fields in {{ totalPages}} pages.</p>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="primaId">Prima ID</label>
              <input type="number" :class="['form-control', invalidFields.indexOf('primaId') === -1 ? '' : 'invalid']" id="primaId" v-model="primaId">
            </div>
          </div>
        </div>
        <div class="row justify-content-between">
          <div class="col-sm-4">
            <div class="form-group">
              <label for="practice-area-section">Sections</label>
              <select class="form-control" id="practice-area-section" v-model="practiceAreaSection">
                <option v-for="(section, index) in practiceAreaSections"
                  :key="index"
                  :value="section"
                  :selected="selectPracticeAreaSection(section)">
                  {{ section }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="practice-area-section">Enable for Questionnaire</label>
              <br>
              <input @click="enableForQ = !enableForQ" :checked="enableForQ" type="checkbox">
            </div>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col-sm-4">
            <div class="form-group">
              <label for="practice-area-section">Practice Area</label>
              <search-select v-model="practiceAreaTag" :multiple="true" :options="tagsFormPA"/>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="practice-area-section">Internal Tag</label>
              <br>
              <search-select v-model="internalTag" :taggable="true" :multiple="true" :options="tagsFormInternal"/>
            </div>
          </div>
        </div>
      </form>

      <h2>Roles</h2>
      <form>
        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role">Role</label>

              <search-select id="addFormRole1" v-model="role1" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix">Prefix</label>
              <input type="text" class="form-control" id="prefix" v-model="prefix1">
            </div>
          </div>
          <div v-if="role1 !== '' && role1 !== '0' && role1._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label ></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role1')" id="maxRole" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role2">Role 2</label>

              <search-select id="addFormRole2" v-model="role2" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix2">Prefix 2</label>
              <input type="text" class="form-control" id="prefix2" v-model="prefix2">
            </div>
          </div>
          <div v-if="role2 !== '' && role2 !== '0' && role2._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label ></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role2')" id="maxRole2" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role3">Role 3</label>

              <search-select id="addFormRole3" v-model="role3" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix3">Prefix 3</label>
              <input type="text" class="form-control" id="prefix3" v-model="prefix3">
            </div>
          </div>
          <div v-if="role3 !== '' && role3 !== '0' && role3._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role3')" id="maxRole3" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role4">Role 4</label>

              <search-select id="addFormRole4" v-model="role4" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix4">Prefix 4</label>
              <input type="text" class="form-control" id="prefix4" v-model="prefix4">
            </div>
          </div>
          <div v-if="role4 !== '' && role4 !== '0' && role4._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role4')" id="maxRole4" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role5">Role 5</label>

              <search-select id="addFormRole5" v-model="role5" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix5">Prefix 5</label>
              <input type="text" class="form-control" id="prefix5" v-model="prefix5">
            </div>
          </div>
          <div v-if="role5 !== '' && role5 !== '0' && role5._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label for=""></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role5')" id="maxRole5" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role6">Role 6</label>

              <search-select id="addFormRole6" v-model="role6" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix6">Prefix 6</label>
              <input type="text" class="form-control" id="prefix6" v-model="prefix6">
            </div>
          </div>
          <div v-if="role6 !== '' && role6 !== '0' && role6._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label for=""></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role6')" id="maxRole6" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role7">Role 7</label>

              <search-select id="addFormRole7" v-model="role7" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix7">Prefix 7</label>
              <input type="text" class="form-control" id="prefix7" v-model="prefix7">
            </div>
          </div>
          <div v-if="role7 !== '' && role7 !== '0' && role7._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label for=""></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role7')" id="maxRole7" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role">Role 8</label>

              <search-select id="addFormRole8" v-model="role8" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix8">Prefix 8</label>
              <input type="text" class="form-control" id="prefix8" v-model="prefix8">
            </div>
          </div>
          <div v-if="role8 !== '' && role8 !== '0' && role8._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label for=""></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role8')" id="maxRole8" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>
      </form>

      <button class="btn btn-success" @click="uploadForm">Save Form</button>

      <div class="scroll-padding"></div>
    </div>

    <max-items-modal
      v-if="isMaxItemsModal === true"
      @close="isMaxItemsModal = false"
      :role="currentRole"
      :formId="formId"
      :maxItems="maxItems"
      @update-maxitems="updateMaxItems"
    />

    <!-- MODAL CONFIRM -->

    <div class="modal-dialog" v-if="showDialog">
      <h1>{{ titleModal }}</h1>
      <p>{{ descModal }}</p>
      <button @click="confirm">{{ confirmText }}</button>
      <button @click="cancel">{{ cancelText }}</button>
    </div>
  </div>
</template>

<script>
import MaxItemsModal from './MaxItemsModal'

import SearchSelect from '../searchSelect/SearchSelect.vue'

import qs from 'qs'

export default {
  name: 'edit-form-modal',

  data () {
    return {
      formId: '',
      jsonData: {},
      formIndex: null,

      invalidFields: [],
      globalTemplate: {},
      totalPages: 0,
      totalFields: 0,

      name: '',
      title: '',
      viewer_url: '',
      status: 'DEV',
      revisionDate: '',
      expirationDate: '',
      displayRevisionDate: '',
      displayExpirationDate: '',
      primaId: '',
      version: 0,
      practiceArea: 'Immigration',
      role1: '',
      prefix1: '',
      role2: '',
      prefix2: '',
      role3: '',
      prefix3: '',
      role4: '',
      prefix4: '',
      role5: '',
      prefix5: '',
      role6: '',
      prefix6: '',
      role7: '',
      prefix7: '',
      role8: '',
      prefix8: '',

      practiceAreaSections: [],
      practiceAreaSection: '',

      isMaxItemsModal: false,
      currentRole: '',
      maxItems: {},

      enableForQ: false,
      showDialog: false,
      titleModal: '',
      descModal: '',
      confrirmText: '',
      cancelText: '',
      confirmAction: '',

      autofillId: null,

      isReplacedTemplate: false,

      tagsFormInternal: [],

      tagsFormPA: [],

      practiceAreaTag: [],
      internalTag: [],

      massiveJsonData: [],
      massiveFormIds: [],
      massiveFormDataBulk: [],
      contFormsBulkAction: 0,
      isBulkAction: false,

      contDefaultGlobal: 0,

      dataUrls: [],

      formData: null
    }
  },

  components: {
    MaxItemsModal,
    SearchSelect
  },

  mounted () {
    let that = this

    this.$bus.on('deleteOldTemplates', function () {
      that.deleteOldTemplates()
    })

    this.$on('setId', function (formId) {
      this.resetFields()
      this.formId = formId
      this.formIndex = this.$store.getters.formIndex(formId)
      this.setFields(this.$store.state.forms[this.formIndex])
    })

    this.$bus.on('setPracticeAreaSections', () => {
      this.$store.state.practiceAreas.forEach(practiceArea => {
        if (this.practiceArea === practiceArea.name) this.practiceAreaSections = practiceArea.sections
      })

      if (this.practiceAreaSections === undefined) {
        this.practiceAreaSections = this.$store.state.practiceAreas[4].sections
      }

      this.practiceAreaSection = this.practiceAreaSections[0]
      this.setFields(this.$store.state.forms[this.formIndex])

      this.getFormTags()
    })

    this.isReplacedTemplate = false

    // BULK ACTIONS UPDATE TEMPLATES

    this.$bus.on('updateTemplatesMassive', (payload) => {
      this.iterationFormsToAddJSON(payload)
    })
  },

  methods: {
    getDataJson (dataUrl) {
      return this.axios.get(
        this.$store.state.apiUrl + 'data/json?pathData=' + dataUrl
      ).then(response => response)
    },

    timeout (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },

    async iterationFormsToAddJSON (payload) {
      for (let contData = 0; contData < payload.formsCheckedList.length; contData++) {
        let formData = this.$store.state.forms.filter(a => a._id === payload.formsCheckedList[contData]._id)[0]
        let dataUrl = formData.viewer_url + '/data.json'
        // let dataUrl = formData.viewer_url.replace('immigration/', '') + '/data.json'

        let dataJson = await this.getDataJson(dataUrl)

        if (dataJson.data && dataJson.data !== undefined && dataJson.data !== null && dataJson.data.filename) {
          formData = JSON.parse(JSON.stringify(formData))
          formData.noData = false
          this.formId = formData._id
          this.jsonData = dataJson.data
          this.formData = {
            formId: formData._id,
            newData: formData
          }

          await this.getTemplates()

          this.$bus.emit('setFormUpdated')

          // await this.timeout(5000)
        } else {
          this.$bus.emit('addNotification', {
            title: 'Add JSON from GitHub repository',
            body: 'There was an error updating this form. Please check the data and try again.',
            type: 'error'
          })

          this.$bus.emit('setFormUpdated')

          this.$bus.emit('setFormInvalidPath', formData)
        }
      }

      this.$store.commit('updateForm', {
        formId: this.formId,
        newData: this.formData.newData
      })

      this.isReplacedTemplate = false
      this.formData = null
    },

    updateTemplatesPages (templates) {
      return new Promise((resolve) => {
        templates.forEach(template => {
          this.updateTemplatePages(template._id).then(responseTemplate => {
            if (responseTemplate.data.success) {
              window.vueBus.emit('addNotification', {
                title: 'Templates Saved',
                body: 'Replaced template information succesfully.',
                type: 'success'
              })

              this.contDefaultGlobal++

              this.$store.dispatch('getQuestionnaire', template._id).then(responseQuestionnaire => {
                if (
                  responseQuestionnaire.data.length > 0 &&
                  responseQuestionnaire.data[0] !== undefined &&
                  responseQuestionnaire.data[0] !== null
                ) {
                  let questionnaireId = responseQuestionnaire.data[0]._id

                  this.$store.dispatch('deleteQuestionnaire', questionnaireId).then(responseDeleteQuestionnaire => {
                    resolve(true)
                  })
                } else resolve(true)
              })

              this.uploadDefaultQuestionnaire(template._id)

              if (this.contDefaultGlobal >= 2) {
                this.contDefaultGlobal = 0

                resolve(true)
              }
            } else {
              window.vueBus.emit('addNotification', {
                title: 'Template Save Error',
                body: 'There was an error updating the template. Please review the data and try again',
                type: 'error'
              })

              resolve(false)
            }
          })
        })
      })
    },

    getFormTags () {
      // GET FORM TAGS

      this.$store.dispatch('getFormTags', {
        tagType: 'practiceArea'
      }).then(response => {
        if (response.data !== undefined && response.data !== null) this.tagsFormPA = response.data
      })

      this.$store.dispatch('getFormTags', {
        tagType: 'internal'
      }).then(response => {
        if (response.data !== undefined && response.data !== null) this.tagsFormInternal = response.data
      })
    },

    confirm () {
      this[this.confirmAction]()
      this.showDialog = false
    },

    cancel () {
      this.showDialog = false
    },

    setFields (formData) {
      if (formData === undefined) return
      this.name = formData.name
      this.title = formData.title
      this.viewer_url = formData.viewer_url
      this.status = formData.status
      this.revisionDate = formData.revisionDate
      this.expirationDate = formData.expirationDate
      this.displayRevisionDate = window.moment.utc(formData.revisionDate).format('MM/DD/YYYY')
      this.displayExpirationDate = window.moment.utc(formData.expirationDate).format('MM/DD/YYYY')
      this.updatedAt = window.moment.utc(formData.updatedAt).format('MM/DD/YYYY')
      this.version = formData.version
      this.primaId = formData.primaId
      this.practiceArea = (formData.practiceArea === 'Migration') || (formData.practiceArea === undefined) ? 'Immigration' : formData.practiceArea
      this.enableForQ = formData.enableForQuestionnaire
      this.practiceAreaTag = formData.practiceAreaTag
      this.internalTag = formData.internalTag

      this.$store.state.practiceAreas.forEach(practiceArea => {
        if (formData.practiceArea === practiceArea.name) this.practiceAreaSections = practiceArea.sections
        else if ((formData.practiceArea === 'Migration') || (formData.practiceArea === undefined)) this.$store.state.practiceAreas[4].sections
      })
      this.practiceAreaSection = (formData.practiceArea === 'Migration') || (formData.practiceArea === undefined) ? this.$store.state.practiceAreas[4].sections[0] : formData.practiceAreaSection
      if (formData.properties !== undefined) {
        let stateRoles = this.$store.state.formRoles

        // SET ASSIGNED ROLES

        // ROLE1
        this.role1 = stateRoles.filter(a => a._id === formData.properties.role1)[0] !== undefined ? stateRoles.filter(a => a._id === formData.properties.role1)[0] : stateRoles[0]
        this.prefix1 = formData.properties.prefix1 !== '0' ? formData.properties.prefix1 : ''

        // ROLE2
        this.role2 = stateRoles.filter(a => a._id === formData.properties.role2)[0] !== undefined ? stateRoles.filter(a => a._id === formData.properties.role2)[0] : stateRoles[0]
        this.prefix2 = formData.properties.prefix2 !== '0' ? formData.properties.prefix2 : ''

        // ROLE3
        this.role3 = stateRoles.filter(a => a._id === formData.properties.role3)[0] !== undefined ? stateRoles.filter(a => a._id === formData.properties.role3)[0] : stateRoles[0]
        this.prefix3 = formData.properties.prefix3 !== '0' ? formData.properties.prefix3 : ''

        // ROLE4
        this.role4 = stateRoles.filter(a => a._id === formData.properties.role4)[0] !== undefined ? stateRoles.filter(a => a._id === formData.properties.role4)[0] : stateRoles[0]
        this.prefix4 = formData.properties.prefix4 !== '0' ? formData.properties.prefix4 : ''

        // ROLE5
        this.role5 = stateRoles.filter(a => a._id === formData.properties.role5)[0] !== undefined ? stateRoles.filter(a => a._id === formData.properties.role5)[0] : stateRoles[0]
        this.prefix5 = formData.properties.prefix5 !== '0' ? formData.properties.prefix5 : ''

        // ROLE6
        this.role6 = stateRoles.filter(a => a._id === formData.properties.role6)[0] !== undefined ? stateRoles.filter(a => a._id === formData.properties.role6)[0] : stateRoles[0]
        this.prefix6 = formData.properties.prefix6 !== '0' ? formData.properties.prefix6 : ''

        // ROLE7
        this.role7 = stateRoles.filter(a => a._id === formData.properties.role7)[0] !== undefined ? stateRoles.filter(a => a._id === formData.properties.role7)[0] : stateRoles[0]
        this.prefix7 = formData.properties.prefix7 !== '0' ? formData.properties.prefix7 : ''

        // ROLE8
        this.role8 = stateRoles.filter(a => a._id === formData.properties.role8)[0] !== undefined ? stateRoles.filter(a => a._id === formData.properties.role8)[0] : stateRoles[0]
        this.prefix8 = formData.properties.prefix8 !== '0' ? formData.properties.prefix8 : ''
      }
    },

    resetFields () {
      this.formIndex = null
      this.formId = ''
      this.invalidFields = []
      this.globalTemplate = {}
      this.name = ''
      this.title = ''
      this.viewer_url = ''
      this.status = 'DEV'
      this.revisionDate = ''
      this.expirationDate = ''
      this.displayRevisionDate = ''
      this.displayExpirationDate = ''
      this.version = 0
      this.primaId = ''
      this.practiceArea = 'Immigration'
      this.practiceAreaSection = ''
      this.role1 = ''
      this.prefix1 = ''
      this.role2 = ''
      this.prefix2 = ''
      this.role3 = ''
      this.prefix3 = ''
      this.role4 = ''
      this.prefix4 = ''
      this.role5 = ''
      this.prefix5 = ''
      this.role6 = ''
      this.prefix6 = ''
      this.role7 = ''
      this.prefix7 = ''
      this.role8 = ''
      this.prefix8 = ''
      this.enableForQ = false
      this.maxItems = {}
      this.practiceAreaTag = []
      this.internalTag = []
    },

    closeModal () {
      this.totalPages = 0
      this.totalFields = 0
      this.isReplacedTemplate = false
      this.$parent.$emit('closeModal')
    },

    getJsonFile () {
      const files = document.getElementById('selectFilesEdit').files

      if (files.length !== 1) {
        return false
      }

      var fr = new FileReader()
      fr.readAsText(files.item(0))

      let that = this
      fr.onload = function (e) {
        that.jsonData = JSON.parse(e.target.result)
        that.showDialog = true
        that.titleModal = 'Replace Templates?'
        that.descModal = 'You are about to replace the default and global templates for this form. Do you want to continue?'
        that.confirmText = 'Confirm'
        that.cancelText = 'Cancel'
        that.confirmAction = 'getTemplates'
      }
    },

    getTemplates () {
      return new Promise((resolve) => {
        this.$store.dispatch('getTemplates', this.formId).then(response => {
          if (response.data.length > 0) {
            this.isReplacedTemplate = true

            let templates = response.data

            this.updateTemplatesPages(templates).then(responseUpdateTemplates => {
              if (this.formData !== null) {
                this.formUpdate(this.formData).then(responseFormUpdate => {
                  if (responseFormUpdate.data.success) {
                    this.$bus.emit('addNotification', {
                      title: 'Form Updated',
                      body: 'The form was updated successfully.',
                      type: 'success'
                    })

                    resolve(true)
                  } else {
                    this.$bus.emit('addNotification', {
                      title: 'Update Error',
                      body: 'There was an error updating this form. Please check the data and try again.',
                      type: 'error'
                    })

                    resolve(false)
                  }
                })
              }
            })
          } else resolve(true)
        })
      })
    },

    getOldTemplates () {
      this.$store.dispatch('getTemplates', this.formId).then(response => {
        if (response.data.length > 0) {
          this.deleteOldQuestionnaires(response.data.map(a => a._id))
          this.getAutofillId()
        }
      })
    },

    deleteOldQuestionnaires (templateIds) {
      templateIds.forEach(templateId => {
        this.$store.dispatch('getQuestionnaire', templateId).then(response => {
          if (
            response.data.length > 0 &&
            response.data[0] !== undefined &&
            response.data[0] !== null
          ) {
            let questionnaireId = response.data[0]._id

            this.$store.dispatch('deleteQuestionnaire', questionnaireId).then(response => {
              console.log('Delete Old questionnaires')
              console.log(response)
            })
          }
        })
      })
    },

    getAutofillId () {
      this.$store.dispatch('getAutofill', this.formId).then(response => {
        if (response.data.length > 0) {
          this.autofillId = response.data[0]._id

          this.deleteOldTemplates()
        }
      })
    },

    deleteOldTemplates () {
      this.createTemplate()

      this.$store.dispatch('deleteOldTemplates', this.formId).then(response => {
        if (response.data.success) {
          this.uploadDefaultTemplate()
        } else {
          this.$bus.emit('addNotification', {
            title: 'Template Error',
            body: 'There was an error removing the current global template. Please try again.',
            type: 'error'
          })
        }
      })
    },

    updateTemplatePages (templateId) {
      let pages = {}
      this.totalPages = 0
      this.totalFields = 0

      for (const pageNum in this.jsonData['pages']) {
        if (this.jsonData.pages.hasOwnProperty(pageNum)) {
          this.totalPages++
          const pageFields = this.jsonData.pages[pageNum]['pageFields']

          if (Object.keys(pageFields).length === 0) pages[pageNum] = []

          for (const fieldName in pageFields) {
            if (pageFields.hasOwnProperty(fieldName)) {
              const field = pageFields[fieldName]

              if (typeof pages[pageNum] === 'undefined') {
                pages[pageNum] = []
              }

              let newData = {
                id: fieldName,
                name: fieldName,
                model: '',
                value: '',
                type: field.fieldType.toLowerCase(),
                tabOrder: field.tabOrder,
                x: field.x,
                y: field.y,
                width: field.width,
                height: field.height,
                maskType: '',
                translations: {}
              }

              if (typeof field.choiceData !== undefined && typeof field.choiceData === 'string') {
                newData['choiceData'] = field.choiceData.slice(1, -1).split(',')
              }

              pages[pageNum].push(newData)
              this.totalFields++
            }
          }
        }
      }

      const postData = {
        templateId,
        newData: pages
      }

      return this.axios.post(
        this.$store.state.apiUrl + 'template/update-pages', postData
      ).then(response => response)
    },

    createTemplate () {
      let templateData = {
        formId: this.formId,
        filename: this.jsonData['filename'],
        name: 'default',
        pages: {},
        fieldGroups: {}
      }

      for (const pageNum in this.jsonData['pages']) {
        if (this.jsonData.pages.hasOwnProperty(pageNum)) {
          this.totalPages++
          const pageFields = this.jsonData.pages[pageNum]['pageFields']

          if (Object.keys(pageFields).length === 0) templateData.pages[pageNum] = []

          for (const fieldName in pageFields) {
            if (pageFields.hasOwnProperty(fieldName)) {
              const field = pageFields[fieldName]

              if (typeof templateData.pages[pageNum] === 'undefined') {
                templateData.pages[pageNum] = []
              }

              let newData = {
                id: fieldName,
                name: fieldName,
                model: '',
                value: '',
                type: field.fieldType.toLowerCase(),
                tabOrder: field.tabOrder,
                x: field.x,
                y: field.y,
                width: field.width,
                height: field.height,
                maskType: '',
                translations: {}
              }

              if (typeof field.choiceData !== undefined && typeof field.choiceData === 'string') {
                newData['choiceData'] = field.choiceData.slice(1, -1).split(',')
              }

              templateData.pages[pageNum].push(newData)
              this.totalFields++
            }
          }
        }
      }

      this.globalTemplate = templateData
    },

    uploadDefaultQuestionnaire (templateId) {
      return new Promise((resolve) => {
        this.$store.dispatch('uploadDefaultQuestionnaire', templateId).then(response => {
          if (response.data.success) {
            this.$store.commit('addQuestionnaire', {
              '_id': response.data.id,
              templateId: templateId
            })

            this.$store.commit('addQuestionnaire', {
              index: 'default',
              data: {
                '_id': response.data.id,
                templateId: templateId,
                data: {}
              }
            })

            resolve(true)
          } else {
            this.$bus.emit('addNotification', {
              title: 'Questionnaire Error',
              body: 'There was an error adding the default questionnaire to this form. Please review the data and try again',
              type: 'error'
            })

            resolve(true)
          }
        })

        this.$store.commit('setLastSaved', Date.now())
      })
    },

    uploadDefaultTemplate () {
      this.$store.dispatch('uploadTemplate', this.globalTemplate).then(response => {
        if (response.data.success) {
          let templateId = response.data.id
          this.uploadDefaultQuestionnaire(templateId)

          // REPLACE OLD TEMPLATE ID ON AUTOFILL
          this.updateAutofill(templateId)
        } else {
          this.$bus.emit('addNotification', {
            title: 'Template Error',
            body: 'There was an error adding the new default template to this form. Please review the data and try again',
            type: 'error'
          })
        }
      })
      this.$store.commit('setLastSaved', Date.now())
    },

    updateAutofill (templateId) {
      this.$store.dispatch('updateAutofill', {
        autofillId: this.autofillId,
        newData: {
          templateId
        }
      }).then(response => {
        console.log('Update autofill')
        console.log(response)
      })
    },

    uploadGlobalTemplate () {
      this.globalTemplate['name'] = 'global'

      this.$store.dispatch('uploadTemplate', this.globalTemplate).then(response => {
        if (response.data.success) {
          this.$bus.emit('addNotification', {
            title: 'Template Updated',
            body: 'The global and default template were updated successfully.',
            type: 'success'
          })
        } else {
          this.$bus.emit('addNotification', {
            title: 'Template Error',
            body: 'There was an error adding the new global template to this form. Please review the data and try again',
            type: 'error'
          })
        }
      })
    },

    uploadForm () {
      let formData = {
        formId: this.formId,
        newData: {
          name: this.name,
          title: this.title,
          viewer_url: this.viewer_url,
          status: this.status,
          revisionDate: new Date(this.displayRevisionDate),
          expirationDate: new Date(this.displayExpirationDate),
          version: this.version,
          primaId: this.primaId,
          practiceArea: this.practiceArea,
          enableForQuestionnaire: this.enableForQ,
          practiceAreaSection: this.practiceAreaSection,
          properties: {
            role1: this.role1._id !== undefined ? this.role1._id : '',
            prefix1: this.prefix1,
            role2: this.role2._id !== undefined ? this.role2._id : '',
            prefix2: this.prefix2,
            role3: this.role3._id !== undefined ? this.role3._id : '',
            prefix3: this.prefix3,
            role4: this.role4._id !== undefined ? this.role4._id : '',
            prefix4: this.prefix4,
            role5: this.role5._id !== undefined ? this.role5._id : '',
            prefix5: this.prefix5,
            role6: this.role6._id !== undefined ? this.role6._id : '',
            prefix6: this.prefix6,
            role7: this.role7._id !== undefined ? this.role7._id : '',
            prefix7: this.prefix7,
            role8: this.role8._id !== undefined ? this.role8._id : '',
            prefix8: this.prefix8
          },
          maxItems: this.$store.state.forms[this.formIndex].maxItems,
          practiceAreaTag: this.practiceAreaTag,
          internalTag: this.internalTag
        }
      }

      this.formUpdate(formData).then(responseFormUpdate => {
        if (responseFormUpdate.data.success) {
          this.$bus.emit('addNotification', {
            title: 'Form Updated',
            body: 'The form was updated successfully.',
            type: 'success'
          })
          this.$store.commit('updateForm', formData)

          this.isReplacedTemplate = false
          this.closeModal()

          this.$bus.emit('getFormList')
        } else {
          this.$bus.emit('addNotification', {
            title: 'Update Error',
            body: 'There was an error updating this form. Please check the data and try again.',
            type: 'error'
          })

          // resolve(false)
        }
      })
    },

    formUpdate (formData) {
      const apiUrl = this.$store.state.apiUrl

      return this.axios.post(
        apiUrl + 'form/update', qs.parse(formData)
      ).then(response => response)
    },

    setPracticeAreaSections (e) {
      this.$store.state.practiceAreas.forEach(practiceArea => {
        if (e.target.value === practiceArea.name) this.practiceAreaSections = practiceArea.sections
      })

      if (this.practiceAreaSections !== undefined) this.practiceAreaSection = this.practiceAreaSections[0]
    },

    selectPracticeAreaSection (section) {
      if (section === this.practiceAreaSection) return true
    },

    showMaxItemsModal (role) {
      this.currentRole = ''
      this.maxItems = this.$store.state.forms[this.formIndex].maxItems !== undefined ? this.$store.state.forms[this.formIndex].maxItems[role] : {}
      this.isMaxItemsModal = true

      this.currentRole = role
    },

    updateMaxItems (maxItems) {
      if (this.$store.state.forms[this.formIndex].maxItems === undefined) this.$store.state.forms[this.formIndex].maxItems = {}
      this.$store.state.forms[this.formIndex].maxItems[this.currentRole] = maxItems
    }
  },

  beforeDestroy () {
    this.$bus.$off('deleteOldTemplates')
    this.$off('setId')
    this.$bus.$off('setPracticeAreaSections')
    this.$bus.$off('updateTemplatesMassive')
  }
}
</script>

<style lang="scss" scoped>
  #editFormModal {
    position: fixed;
    top: 5%;
    left: 50%;
    margin-left: -40%;
    width: 80%;
    height: 80%;
    z-index: 1050;
    overflow: hidden;
    outline: 0;

    background-color: #eee;
    border: 1px solid black;
    border-radius: 5px;
    padding: 0;

    .header {
      background-color: #2d5f8b;
      color: white;
      font-size: 18px;
      padding: 5px 10px 5px 10px;

      .btn-close {
        cursor: pointer;
        color: #FFF;
        font-size: 34px;
        font-weight: bold;
        line-height: 24px;
      }
    }

    .forms-wrapper {
      overflow-y: scroll;
      width: 100%;
      height: 100%;
      padding: 15px;
    }

    .invalid {
      border: 2px solid red;
    }

    .scroll-padding {
      display: block;
      width: 100%;
      height: 50px;
    }
  }

  .modal-dialog {
    pointer-events: auto;
    margin: auto;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: white;
    border: 2px solid black;
    border-radius: 8px;
    height: 200px;
    padding: 10px;
    user-select: none;
    z-index: 2000;

    h1 {
      text-align: center;
    }

    button {
      background-color: #2d5f8b;
      color: white;
      border: none;
      box-shadow: 2px 2px 2px #555;
      min-width: 100px;
      min-height: 35px;
      float: right;
      margin-left: 25px;

      &:hover {
        background-color: #2C7FFF;
        box-shadow: 2px 2px 2px #333;
      }

      &:active {
        box-shadow: 1px 1px 1px #333;
      }

      &:focus {
        outline: none;
      }
    }
  }
</style>







// WEBPACK FOOTER //
// src/components/form-grid/EditFormModal.vue